export const walletLogoUrl = 'https://cdn6.agoda.net/images/wallet/email-assets/agoda-wallet-badge.svg';
